import Widget from "components/Layout/Widget";
import RecordLabel from "components/RecordLabel";
import { DashboardWidgetConfig, FeRecordType } from "config/config";
import "./PercentageList.scss";

interface PercentagePerLocationProps {
    data: {
        link: string | null;
        name: string;
        image: string | null;
        percentage: number;
        type: FeRecordType;
    };
}

const PercentagePerLocation = ({ data }: PercentagePerLocationProps) => {
    const { link, name, image, percentage, type } = data;
    return (
        <div className="percentage-list__item">
            <RecordLabel link={link} name={name} image={image} iconByType={type} />
            <div className="flex items-center">
                <div className="percentage-list__bar flex-1">
                    <div style={{ width: `${percentage}%` }} />
                </div>
                <span className="text-bold text-sm">{percentage}%</span>
            </div>
        </div>
    );
};

export const PercentageList = ({
    config,
    stats,
}: {
    config: DashboardWidgetConfig;
    stats: any;
}) => {
    const data = config?.dto?.({ stats });

    if (data?.length === 0) return <Widget.Empty />;

    // Render all per-project rows inside a single container so they are one
    // child of `.widget` (matching the sibling LatestList / LatestEdits
    // widgets). Otherwise each row became a direct `.widget` child and picked
    // up the `.widget > *:not(:last-child){margin-bottom:30px}` gap on top of
    // its own item margin, making this widget taller than its neighbours.
    return (
        <div className="percentage-list" data-testid="percentage-list">
            {data.map((dataPerLocation) => (
                <PercentagePerLocation data={dataPerLocation} key={dataPerLocation.name} />
            ))}
        </div>
    );
};
